import { IDonHangCreateRequest } from "../../model/request/ban-hang/IDonHangCreateRequest";
import { IDonHangDoiTraRequest } from "../../model/request/ban-hang/IDonHangDoiTraRequest";
import { ICommonRequest } from "../../model/request/ICommonRequest";
import { IDonHangSearchRequest } from "../../model/request/don-hang/IDonHangSearchRequest";
import { ISendEmailRequest } from "../../model/request/don-hang/SendEmailRequest";
import { apiClient } from "../apiClient";

export const DON_HANG_API_RESOURCE = "don-hang"
export const donHangApi = {
    Create: (request: IDonHangCreateRequest) => apiClient.post(`${DON_HANG_API_RESOURCE}`, request),
    GetHtmlPrint: (id: number) => apiClient.get(`${DON_HANG_API_RESOURCE}/${id}/html`),
    GetHtmlPrintSmall: (id: number) => apiClient.get(`${DON_HANG_API_RESOURCE}/${id}/html-small`),
    GetByHocSinh: (id: number) => apiClient.get(`${DON_HANG_API_RESOURCE}/hoc-sinh/${id}`),
    SelectAll: (payload: ICommonRequest) => apiClient.post(`${DON_HANG_API_RESOURCE}/select-all`, payload),
    Search: (request: IDonHangSearchRequest) => apiClient.post(`${DON_HANG_API_RESOURCE}/search`, request),
    SelectViewDetail: (id: number) => apiClient.get(`${DON_HANG_API_RESOURCE}/detail/${id}`),
    HuyDonHang: (request: { id: number, ly_do_huy: string }) => apiClient.post(`${DON_HANG_API_RESOURCE}/huy-don-hang`, request),
    DoiTraDonHang: (request: IDonHangDoiTraRequest) => apiClient.post(`${DON_HANG_API_RESOURCE}/doi-tra`, request),
    CapNhatDaGiaoHang: (id: number) => apiClient.put(`${DON_HANG_API_RESOURCE}/cap-nhat-da-giao-hang/${id}`),
    SendEmail: (request: ISendEmailRequest) => apiClient.post(`${DON_HANG_API_RESOURCE}/send-email`, request),
    Export: (data: any) => apiClient.postBlob(`${DON_HANG_API_RESOURCE}/export`, data),
    ExportExcel: (request: any) => apiClient.postBlob(`${DON_HANG_API_RESOURCE}/export-excel`, request),
}